<template>
  <div id="chatOnlineOwlContainer">
    <p v-if="online.length" class="desc desc--lightgrey">{{ trans.get('pages:chat.current_online_header') }}</p>

    <div v-if="show && online.length" class="w-chat__owl-carousel">
      <OwlCarousel :items="4" :mouseDrag="true" :touchDrag="true" :pullDrag="false" :loop="false" :freeDrag="false" :nav="false" :responsive="responsive">
        <div
          v-for="(profile,k) in online"
          class="js-online-profile"
          :data-profile-id="k"
        >
          <div class="avatar-single avatar-single--small avatar-single--circle avatar-single--shadow" :style="{'background-image':'url(' + profile.avatar_url + '?p=tiny)'}">
            <div class="avatar-single__online-status"></div>
          </div>
        </div>
      </OwlCarousel>
    </div>

    <!--        TEST OWL FRONTEND-->

    <!--        <div class="w-chat__owl-carousel">-->
    <!--            <OwlCarousel :items="4" :mouseDrag="true" :touchDrag="true" :pullDrag="false" :loop="false" :freeDrag="false" :nav="false" :responsive="responsive">-->
    <!--                <div v-for="(profile,k) in [1,2,3,4]"-->
    <!--                     class="js-online-profile"-->
    <!--                     :data-profile-id="k">-->
    <!--                    <div class="avatar-single avatar-single&#45;&#45;small avatar-single&#45;&#45;circle avatar-single&#45;&#45;shadow" :style="{'background-image':'url(\'https://loremflickr.com/320/240/brazil,rio\')'}">-->
    <!--                        <div class="avatar-single__online-status"></div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </OwlCarousel>-->
    <!--        </div>-->

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OwlCarousel from '../../modules/OwlCarousel';

export default {
  name: 'OnlineCard',
  components: { OwlCarousel },
  data() {
    return {
      responsive: {
        0: {
          items: 4,
          nav: false,
          loop: true,
        },
        350: {
          items: 6,
          nav: false,
          loop: true,
        },
        450: {
          items: 8,
          nav: false,
          loop: true,
        },
        900: {
          items: 4,
          nav: false,
          loop: true,
        }
      },
      show: false,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    ...mapGetters('profiles', {
      online: 'getChatOnline',
    }),
  },
  watch: {
    online: function () {
      let vm = this;
      vm.show = false;
      vm.$nextTick(() => {
        vm.show = true;
      });
    }
  },
  methods: {
    clickAction(profile) {
      if (profile.is_blurred_avatar) {
        this.$eventHub.$emit('BuyProfileModalOpen', { profileId: profile.id, form: { distance: 500 }, avatarUrl: profile.avatar_url });
      } else {
        // go to chat
        // this.$emit('openChat', profile.id);
        this.$router.push({ name: 'profile', params: { id: profile.id } });
      }
    },
    buyProfile: function (profile) {
      let index = this.online.findIndex((x) => {
        return x.id === profile.id;
      });
      this.$set(this.online, index, profile);
    },
  },
  mounted() {
    let vm = this;
    this.$store.dispatch('profiles/loadChatOnline');

    vm.$eventHub.$on('FreshProfile', (profile) => {
      vm.$store.commit('profiles/setChatOnlineProfile', profile);
    });

    vm.$nextTick(() => {
      $('#chatOnlineOwlContainer').on('click', '.js-online-profile', function () {
        vm.clickAction(vm.online[this.dataset.profileId]);
      });
    });
  }
};
</script>
